<template>
  <v-row justify="start" justify-md="space-around" justify-lg="start" >
    <v-col cols="12" md="10" lg="6">
      <transition name="fade-transition" mode="out-in">
        <ManageProperty :darkMode="$props.darkMode" v-if="isNew !== null" :isNew="isNew" :id="propertyID"></ManageProperty>
      </transition>
    </v-col>
  </v-row>
</template>

<script>
  import ManageProperty from "../../components/Properties/ManageProperty";
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: 'ManagePropertyView',
    components: {
      ManageProperty
    },
    watch: {
      '$route.params.id': function () {
        this.initialize();
      },
      '$route': function (to, from) {
        console.log(to, from);
      },
      '$route.name': function () {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    data: () => ({
      isNew: null,
    }),
    props: {
      id: String,
      darkMode:{
        type:Boolean,
        default: false
      },

    },
    methods: {
      async initialize() {
        if (this.$props.id) {
          await this.setProperty(this.$props.id);
          this.isNew = false;
        } else {
          await this.clearProperty();
          this.isNew = true;
        }
      },
      ...mapActions([
        'setProperty',
        'clearProperty'
      ]),


    },
    computed: {
      ...mapGetters([
        'propertyID',
      ]),
    },
  }
</script>

<style lang="scss" scoped>

</style>